import { isProd } from '@/config';
import chalk from 'chalk';

const formatLog = (level: string, message: string, ...args: unknown[]) => {
    const timestamp = new Date().toISOString();
    const levelStr = `[${level.toUpperCase()}]:`;
    let colorizedLevelStr;

    switch (level) {
        case 'log':
            colorizedLevelStr = chalk.blue(levelStr);
            break;
        case 'warn':
            colorizedLevelStr = chalk.yellow(levelStr);
            break;
        case 'error':
            colorizedLevelStr = chalk.red(levelStr);
            break;
        case 'info':
            colorizedLevelStr = chalk.green(levelStr);
            break;
        case 'debug':
            colorizedLevelStr = chalk.magenta(levelStr);
            break;
        default:
            colorizedLevelStr = chalk.white(levelStr);
            break;
    }

    return [chalk.gray(`[${timestamp}]`), colorizedLevelStr, message, ...args];
};
type LogLevel = 'log' | 'warn' | 'error' | 'info' | 'debug';

const createLoggerMethod = (level: LogLevel, allowProdLogging: boolean) => {
    return (message: string, ...extraParams: unknown[]) => {
        const shouldLog = allowProdLogging || !isProd();

        if (shouldLog) {
            console[level](...formatLog(level, message, ...extraParams));
        }
    };
};

const createLogger = (allowProdLogging: boolean) => ({
    log: createLoggerMethod('log', allowProdLogging),
    warn: createLoggerMethod('warn', allowProdLogging),
    error: createLoggerMethod('error', allowProdLogging),
    info: createLoggerMethod('info', allowProdLogging),
    debug: createLoggerMethod('debug', allowProdLogging),
});

const logger = createLogger(false);
const prodLogger = createLogger(true);

export { logger, prodLogger };
